<template>
    <el-dialog
    title="《用户隐私政策》"
    width="40%"
    top="50px"
    v-model="dialogVisible"
    :before-close="handleClose">
    <div class="oneBox">
        <div>
            我们非常重视您的个人信息保护，并会尽全力保护您的个人信息安全可靠。为使用我司的移动终端应用软件和其他客户端或平台（以下简称“本平台”）所提供的服务，您应当阅读并遵守《用户隐私协议》（以下简称“本协议”）。请您务必审慎阅读、充分理解各条款内容，除非您已阅读并接受本协议所有条款，同时承诺按照国家有关法律法规，遵守法律法规、社会主义制度、国家利益、公民合法权益、公共秩序、社会道德风尚和信息真实性等七条底线，不发布、传播违规违法的信息。否则您无权使用本公司提供的服务，您应立即停止注册、使用。您注册、使用平台服务行为即视为您已阅读并同意本协议各项条款的约束。
        </div>
        <br>
        <h1>一、您提供的信息</h1>
        <div>
            您申请开通或注册成为我们的用户或使用我们的服务时，向我们提供的相关个人信息，包括您的姓名（名称）、电话号码、所属公司/学校、联系人等。 您提供的上述信息，将在您使用本网站服务期间持续授权我们使用。在您申请注销账号时，我们将停止使用上述信息。
        </div>
        <br>
        <h1> 二、 第三方分享的您的信息</h1>
        <div>
            为给您提供服务，我们可能会从关联公司、业务合作伙伴等第三方来源获得您的相关信息。例如当您使用我们的关联公司、业务合作伙伴等第三方开通了关爱终端业务，您向其提供的信息可能会转交给我们，以便我们为您提供服务。
        </div>
        <br>
        <h1> 三、 您在使用服务过程中我们可能收集的信息</h1>
        <div>
            （1）日志信息：指您使用我们服务时，系统可能通过 cookies、web beacon 或其他方式自动采集的技术信息，包括设备或软件信息，例如您的移动设备、网页浏览器或您用于接入我们的服务的其他程序所提供的配置信息、您的IP地址和您的移动设备所用的版本和设备识别码；
        
        </div>
        <div>
            （2）手机账户信息：指您手机登录账户的信息，例如在您选择使用手机账号登录我们的服务时，我们会获取您的手机账号等相关信息。
        </div>
        <br>
        
        <h1> 四、 我们如何使用您的信息，我们主要在以下情况使用到您的信息。</h1>
        <div>
            （1）通过您的手机号码实现密码找回功能；
        </div>
        <div>
            （2）通过您的账号登录平台；
        </div>
        <div>
            （3）通过您关联的终端、设备，给您推送、统计终端、设备的相关的使用、设置、情况等信息；
        </div>
        <div>
            （4）通过您的邮箱地址反馈回复您的问题；
        </div>
        <div>
            （5）合法的第三方平台、机构设置、查看您的关联的终端的设置、记录。
        </div>
        <div>
            在收集您的个人信息后，我们将通过技术手段对数据进行去标识化处理，去标识化处理的信息将无法识别主体。请您了解并同意，在此情况下我们有权使用已经去标识化的信息；并在符合相关法律法规的前提下，我们有权对包括您的个人信息在内的用户数据库进行整体化分析和利用。
        </div>
        <br>
        <h1> 五、其他情况下使用您的信息</h1>
        <div>
            当我们要将信息用于本政策未载明的其它用途时，会事先征求您的同意。
        </div>
        <br>
        <h1> 六、 您充分知晓，以下情形中我们使用个人信息无需征得您的授权同意</h1>
        <div>
            当我们要将信息用于本政策未载明的其它用途时，会事先征求您的同意。
        </div>
        <div>
            （1）与国家安全、国防安全有关的；
        </div>
        <div>
            （2）与 公共安全、公共卫生、重大公共利益有关的;
        </div>
        <div>
            （3）与犯罪侦查、起诉、审判和判决执行等有关的；
        </div>
        <div>
            （4）出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；
        </div>
        <div>
            （5）所收集的个人信息是个人信息主体自行向社会公众公开的；
        </div>
        <div>
            （6）从合法公开披露的信息中收集的您的个人信息的，如合法的新闻报道、政府信息公开等渠道；
        </div>
        <div>
            （7）根据您的要求签订合同所必需的；
        </div>
        <div>
            （8）用于维护所提供的产品与/或服务的安全稳定运行所必需的，例如发现、处置产品与/或服务的故障；
        </div>
        <div>
            （9）为合法的新闻报道所必需的；
        </div>
        <div>
            （10）学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；
        </div>
        <div>
            （11）法律法规规定的其他情形。
        </div>
        <br>
        <h1> 七、 我们如何共享、转让、公开披露您的个人信息</h1>
        <div>
            （1）共享
        </div>
        <div>
            我们不会与任何公司、组织和个人分享您的个人信息，但以下情况除外：
        </div>
        <div>
            1、在获取明确同意的情况下共享：获得您的明确同意后，我们会与其他方共享您的个人信息。
        </div>
        <div>
            2、我们可能会根据法律法规规定，或按政府主管部门的强制性要求，对外共享您的个人信息。
        </div>
        <div>
            3、与我们的关联公司共享：您的个人信息可能会与我们的关联公司共享。我们只会共享必要的个人信息，且受本个人信息保护政策中所声明目的的约束。关联公司如要改变个人信息的处理目的，将再次征求您的授权同意。
        </div>
        <div>
            （2）转让
        </div>
        <div>
            我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：
        </div>
        <div>
            1、在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息；
        </div>
        <div>
            2、在涉及合并、收购或破产清算时，如涉及到个人信息转让，我们会在要求新的持有您个人信息的公司、组织继续受此个人信息保护政策的约束，否则我们将要求该公司、组织重新向您征求授权同意。
        </div>
        <div>
            （3）公开披露
        </div>
        <div>
            我们仅会在以下情况下，公开披露您的个人信息：
        </div>
        <div>
            1、获得您明确同意后；
        </div>
        <div>
            2、基于法律的披露：在法律、法律程序、诉讼或政府主管部门强制性要求的情况下，我们可能会公开披露您的个人信息。
        </div>
        <br>
        <h1>八、其他情况声明</h1>
        <div>
            请您不要将的帐号、密码转让或出借予他人使用，互联网上不排除因黑客行为或用户的保管疏忽导致帐号、密码遭他人非法使用或隐私信息外泄，此类情况与本平台无关。
        </div>
        <br>
        <h1> 九、我们如何保护您的个人信息</h1>
        <div>
            （1）我们会严格按照《网络安全法》、《全国人民代表大会常务委员会关于加强网络信息保护的决定》、《电信和互联网用户个人信息保护规定》（工业和信息化部令第24号）、《电话用户真实身份信息登记规定》（工业和信息化部令第25号）等法律法规的相关要求，建立信息安全保障制度，采取技术措施和其他必要措施保护您的个人信息安全。
        </div>
        <div>
            （2）我们只会在达成本政策所述目的所需的期限内保留您的个人信息，除非需要延长保留期或受到法律的允许。
        </div>
        <div>
            （3）请您理解，互联网环境并非百分之百安全，我们将尽力确保或担保您发送给我们的任何信息的安全性，但由于技术的限制及可能存在的各种恶意手段，即便竭尽所能加强安全措施，也不可能始终保证信息百分之百安全。在不幸发生个人信息安全事件后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。
        </div>
        <br>
        <h1>十、我们如何处理未成年人的个人信息</h1>
        <div>
            （1）我们非常重视对未成年人个人信息的保护。若您是18周岁以下的未成年人，在使用我们的服务前，应事先取得您家长或法定监护人的书面同意。我们将根据国家相关法律法规的规定保护未成年人的个人信息。
        </div>
        <div>
            （2）对于经父母或法定监护人同意而收集未成年人个人信息的情况，我们只会在受到法律允许、父母或监护人明确同意或者保护未成年人所必要的情况下使用或公开披露此信息。
        </div>
        <div>
            （3）如果我们发现自己在未事先获得可证实的父母或法定监护人同意的情况下收集了未成年人的个人信息，则会设法尽快删除相关数据。
        </div>
        <br>
        <h1> 十一、 如何联系我们</h1>
        <div>
            如果您对本个人信息保护政策有任何疑问、意见或建议，可以随时联系我们的运营服务人员，我们会积极进行查证、处理并尽快答复。
        </div>
        <br>


        
        
        
        
       
    </div>
        </el-dialog>
</template>
<script>
export default {
   name: '',
   components: {
    
   },
   props: {
     
   },
   data() {
     return {
        // userValue:true
        dialogVisible: true,
     }
   },
   computed: {
     
   },
   watch: {
     
   },
   mounted() {
     
   },
   methods: {
    handleClose() {
        // this.dialogVisible= false
        this.$emit('userBack')
      }
   }
};
</script>
    <style lang='scss' scoped>
    .oneBox{
        height:700px
        ;
        overflow: auto;
        // width: 600px;
        padding:0px  30px;
        font-size: 14px;
        // font-weight: 500;
        margin-top: 3px;
        color: black;
        ;
    }
    h1{
        font-size: 16px;
    }
</style>